import axios from "axios";
import { getSecureItem, removeSecureItem } from "./secureStorage";
export const baseURL = process.env.REACT_APP_API_BASE_URL;

const Api = axios.create({
  baseURL,
});

Api.interceptors.request.use((req) => {
  const token = getSecureItem("accessToken");
  if (token) {
    req.headers.Authorization = token;
  }
  return req;
});

Api.defaults.headers.post["Content-Type"] = "application/json";

Api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response && error?.response?.status === 401) {
      removeSecureItem("accessToken");
      removeSecureItem("userData");
      window.location.assign("/");
    }

    if (error?.response && error?.response?.status === 403) {
      window.location.assign("/admin/dashboard");
    }
    return Promise.reject(error);
  }
);

export default Api; 
